import { useMemo } from 'react';

export default function useVault(vaults, currency, lockPeriod) {
  return useMemo(() => {
    return vaults.find(
      vault => currency === vault.currency_id && parseInt(lockPeriod) === vault.lock_in_period_seconds
    );
  }, [vaults, currency, lockPeriod]);
}
